module.exports = "/ui/main/images/boxnow.png?ff1dbb1ca5163d807083eb43fcb2148c";